import { GetStaticProps } from 'next';
import React from 'react';

import { InConvoWithOverviewSingleFieldsFragment, PageInformationFieldsFragment } from 'api/graphql-types';
import client from 'api/apollo-client';
import { getServerPageGetInConvoWithOverview } from 'api/graphql-helper';

import Layout from 'modules/layout/layout';
import { ModuleBuilder } from 'modules/module-builder/module-builder';
import { Head } from 'modules/head/head';
import IntroHeader from 'modules/intro-header/intro-header';

import { initialState as settingsInitialState } from 'redux/stores/settings';
import { initialState as inConvoWithInitialState } from 'redux/stores/in-convo-with';

import { getStrapiParametersFromContext } from 'utils/strapi-parameters';
import { ROUTES } from 'constants/routes';
import { IBasePageProps } from 'types/page';

interface IInConvoWithOverviewPageProps extends IBasePageProps {
	inConvoWithOverview?: InConvoWithOverviewSingleFieldsFragment;
	pageInformation?: PageInformationFieldsFragment;
}

const InConvoWithOverviewPage = (props: IInConvoWithOverviewPageProps): React.JSX.Element => {
	const modules = props.inConvoWithOverview?.modules || [];
	const seoModule = props?.inConvoWithOverview?.seo;

	return (
		<Layout navbar={props?.pageInformation?.navbar} footer={props?.pageInformation?.footer}>
			<Head seoModule={seoModule} seoParent={props.pageInformation?.seo} />
			<IntroHeader module={props?.inConvoWithOverview?.header} slug={ROUTES.IN_CONVO_WITH.fullPath} />
			<ModuleBuilder modules={modules} slug={ROUTES.IN_CONVO_WITH.fullPath} />
		</Layout>
	);
};

export const getStaticProps: GetStaticProps = async (ctx) => {
	try {
		const { locale, publicationState, draftMode } = getStrapiParametersFromContext(ctx);

		const result = await getServerPageGetInConvoWithOverview({ variables: { locale, publicationState } }, client);
		const {
			pageInformation,
			inConvoWithOverview,
			inConvoWithArticles_connection: inConvoWithArticles
		} = result.props.data;

		if (inConvoWithOverview == null) {
			return {
				notFound: true
			};
		}

		return {
			props: {
				pageInformation: pageInformation?.data?.attributes,
				inConvoWithOverview: inConvoWithOverview.data?.attributes,
				initialReduxState: {
					settings: {
						...settingsInitialState,
						publicationState,
						draftMode,
						contentType: 'in-convo-with-overview',
						contentTypeId: inConvoWithOverview?.data?.documentId,
						showNeutralStyle: true,
						hideLanguageSwitcher: true,
						hideSearchbar: true,
						isSubsite: true
					},
					inConvoWith: {
						...inConvoWithInitialState,
						inConvoWithArticles: inConvoWithArticles?.data?.map((item) => item.attributes),
						totalInConvoWithArticles: inConvoWithArticles?.pageInfo?.total
					}
				}
			},
			revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_TIME_IN_SECONDS)
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('Error in in gesprek met overview', error);

		return {
			notFound: true
		};
	}
};

export default InConvoWithOverviewPage;
